// The iframe languages use a few codes of their own, while plural rules need
// the standard ones.
const STANDARD_CODES = { cz: "cs", si: "sl", ua: "uk" };

const ENGLISH = {
  apartments_count: { one: "{{count}} apartment", other: "{{count}} apartments" },
  guests_count: { one: "{{count}} guest", other: "{{count}} guests" },
  for_guests: { one: "for {{count}} guest", other: "for {{count}} guests" },
  nights_count: { one: "{{count}} night", other: "{{count}} nights" },
  adults_count: { one: "{{count}} adult", other: "{{count}} adults" },
  children_count: { one: "{{count}} child", other: "{{count}} children" },
  years_count: { one: "{{count}} year", other: "{{count}} years" },
};

export const pluralCategory = (language, count) => {
  const code = String(language || "en").split("-")[0];

  try {
    return new Intl.PluralRules(STANDARD_CODES[code] || code).select(count);
  } catch (error) {
    return count === 1 ? "one" : "other";
  }
};

// A text with a number in the right plural form, e.g. "2 hostia" or "5 hostí".
// Keys are stored as `<key>_<category>`: one, two, few, many or other.
export const translateCount = (t, language, key, count) => {
  const english = ENGLISH[key] || {};
  const fallback = (english[count === 1 ? "one" : "other"] || "{{count}}").replace(
    "{{count}}",
    count
  );
  const category = pluralCategory(language, count);

  return t(`${key}_${category}`, {
    count,
    defaultValue: t(`${key}_other`, { count, defaultValue: fallback }),
  });
};
